import React, { Component } from "react";
//import { Textbox, Textarea } from 'react-inputs-validation';
//import 'react-inputs-validation/lib/react-inputs-validation.min.css';
import $ from "jquery";
import { CLIENT_CREATE, LOGIN_TYPE_ADMIN, GetSettingURL } from './helper/Constants'
import { Alert } from 'rsuite';
//import 'rsuite/dist/styles/rsuite-default.css'
import Apihelpers from "./helper/ApiHelper";
import {NavLink } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import UnAuthorised from "./UnAuthorised";
import Header from "./include/Header";

//import Select2 from 'react-select2-wrapper';
//import 'react-select2-wrapper/css/select2.css';
//var split = require('react-split')


class CreateClient extends Component {

  constructor(props) {
    super(props);
    this.state = {
      clientname: "",
      clientnumber: "",
      clientemail: "",
      clientaddress: "",

      send_make_model_id:false,
      send_make_model_suggestion_id:false,
      send_challan_fasttag_details:false,
      rc_prime_retry_call:false,
      is_send_incomplete_rcprime_vehicle_info:false,
      rc_prime_response_user_specific_return_format:false,
      rc_prime_third_party_call_enable:false,
      free_rc_api_hit_allow:false,
      third_party_call_in_rc:false,
      ip_address_enable_for_rc_prime:false,
      allowed_ip_addresses_for_rc_prime:[],
      bbUserBusinessUnit: '',
      buUnites:[]
    };
  }

  componentDidMount() {
    //this.getPlanList();
    $(".selectInput").select2({
      placeholder: "type ip address",
      tags: true,
      tokenSeparators: [',', ' ']
    });
    this.get_Data_Of_Setting();
  }
  get_Data_Of_Setting = () => {
    Apihelpers.getdataresponse(GetSettingURL).then(res => {
      var data = res.data.data;
      console.log('data',data);
      this.setState({
        buUnites:data.bbuser_business_unit_options || []
      });
    });
  }

  callCreateClientApi(createClientPostData) {
    $(".loader").show();
    Apihelpers.postdataresponse(CLIENT_CREATE, createClientPostData).then(res => {
      if (res.data.status === true) {
        $(".loader").hide();
        let id = res.data.data._id;
        Alert.success("Client Created Successfully...");
        setTimeout(()=>{
          window.location.href = window.location.origin+'/admin/client-edit-view/'+id;
        },500)
      } else {
        alert(res.data.message);
        this.setState({
          currentRender: 1
        });
      }
    });
  }

  createClientSubmit = (e) => {
    e.preventDefault();
    if(!this.state.clientname.replace(/\s+/g, '')) {
      alert('Please add valid name');
      return;
    }
    if(!this.state.clientaddress.replace(/\s+/g, '')) {
      alert('Please add valid address');
      return;
    }
    let createClientPostData = {
      'email': this.state.clientemail,
      'business_name': this.state.clientname,
      'name': this.state.clientname,
      'mobilenumber': this.state.clientnumber,
      'address': this.state.clientaddress,
      'active_plan': '{"balance": "100","plan_type": "Prepaid","service":[]}',

      'send_make_model_id':this.state.send_make_model_id,
      'send_make_model_suggestion_id':this.state.send_make_model_suggestion_id,
      'send_challan_fasttag_details': this.state.send_challan_fasttag_details,
      'rc_prime_retry_call':this.state.rc_prime_retry_call,
      'is_send_incomplete_rcprime_vehicle_info': this.state.is_send_incomplete_rcprime_vehicle_info,
      'rc_prime_response_user_specific_return_format': this.state.rc_prime_response_user_specific_return_format,
      'rc_prime_third_party_call_enable': this.state.rc_prime_third_party_call_enable,
      'free_rc_api_hit_allow': this.state.free_rc_api_hit_allow,
      'third_party_call_in_rc': this.state.third_party_call_in_rc,
      'business_unit': this.state.bbUserBusinessUnit
    };

    if ($("#allowed_ip_address").val() !== undefined) {
      createClientPostData.ip_address_enable = this.state.ip_address_enable_for_rc_prime; 
      createClientPostData.allowed_ip_addresses = $("#allowed_ip_address").val().toString();
    }

    console.log('createClientPostData',createClientPostData);

    this.callCreateClientApi(createClientPostData);
  }
  render() {
    if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
      return (
        <React.Fragment>
          <div className="wrapper">
            <Header />
            <div className="container">
              <div className="addClientBox">
                <div>
                  <div className="heading"> Create Client </div>
                  <form className="form" onSubmit={this.createClientSubmit}>
                    <div className="row">
                      <div className="col-4">
                        <div className="form-group">
                          <label className="control-title">Client name <span className="ex">*</span></label>
                          <input className="form-control" type="text" required placeholder="Enter Client Name" name="" onChange={(e)=>{this.setState({clientname:e.target.value})}} />
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="control-title">E-Mail <span className="ex">*</span></label>
                          <input className="form-control" type="email" required placeholder="Enter Email ID" name="" onChange={(e)=>{this.setState({clientemail:e.target.value})}} />
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          {this.state.mobilenumber}
                          <label className="control-title">Mobile Number <span className="ex">*</span></label>
                          <input className="form-control" type="text" required placeholder="Enter Number" name="" minLength={10} maxLength={10} onChange={(e)=>{this.setState({clientnumber:e.target.value})}} />
                        </div>
                      </div>
                      <div className="col-8">
                        <div className="form-group">
                          <label className="control-title">Address <span className="ex">*</span></label>
                          <textarea className="form-control" placeholder="Enter Address" onChange={(e)=>{this.setState({clientaddress:e.target.value})}} required></textarea>
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group">
                          <label className="control-title">Business Unit <span className="ex">*</span></label>
                          <select className="form-control" required="required" onChange={(e)=>{
                            this.setState({
                              bbUserBusinessUnit: e.target.value
                            })
                          }} value={this.state.bbUserBusinessUnit}>
                            <option value="">--select--</option>
                            {
                              this.state.buUnites.map((it)=>{
                                return(
                                  <option key={it} value={it}>{it}</option>
                                )
                              })
                            }
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="plan-configration">
                      <h2>Service Plan Configration</h2>
                    
                      <div className="row">
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">Send Make Model ID</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="send_make_model_id" type="checkbox" onChange={(e) => this.setState({send_make_model_id:e.target.checked})} checked={this.state.send_make_model_id} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">Send Make Model Suggestion ID</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="send_make_model_suggestion_id" type="checkbox" onChange={(e) => this.setState({send_make_model_suggestion_id:e.target.checked})} checked={this.state.send_make_model_suggestion_id} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">Is send incomplete rcprime vehicle info</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="is_send_incomplete_rcprime_vehicle_info" type="checkbox" onChange={(e) => this.setState({is_send_incomplete_rcprime_vehicle_info:e.target.checked})} checked={this.state.is_send_incomplete_rcprime_vehicle_info} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">Send Challan FASTag Details</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="send_challan_fasttag_details" type="checkbox" onChange={(e) => this.setState({send_challan_fasttag_details:e.target.checked})} checked={this.state.send_challan_fasttag_details} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">RC Prime Retry Call</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="rc_prime_retry_call" type="checkbox" onChange={(e) => this.setState({rc_prime_retry_call:e.target.checked})} checked={this.state.rc_prime_retry_call} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">Free RC API hit allow</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="free_rc_api_hit_allow" type="checkbox" onChange={(e) => this.setState({free_rc_api_hit_allow:e.target.checked})} checked={this.state.free_rc_api_hit_allow} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">Third party call in Free RC</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="third_party_call_in_rc" type="checkbox" onChange={(e) => this.setState({third_party_call_in_rc:e.target.checked})} checked={this.state.third_party_call_in_rc} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">RcPrime response user specific return format</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="rc_prime_response_user_specific_return_format" type="checkbox" onChange={(e) => this.setState({rc_prime_response_user_specific_return_format:e.target.checked})} checked={this.state.rc_prime_response_user_specific_return_format} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="control-title">RC Prime Third party Call Enable</label>
                            <div className="formSwithc">
                              <label className="switch">
                              <input name="rc_prime_third_party_call_enable" type="checkbox" onChange={(e) => this.setState({rc_prime_third_party_call_enable:e.target.checked})} checked={this.state.rc_prime_third_party_call_enable} />
                                  <span className="slider round"></span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group">
                            <label className="form-title">Allowed Ip Address</label>
                            <div className="formSwithc">
                                <label className="switch">
                                    <input name="" type="checkbox" onChange={(e) => this.setState({ip_address_enable_for_rc_prime:e.target.checked})} checked={this.state.ip_address_enable_for_rc_prime} />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-7">
                            <div className="form-group" style={(this.state.ip_address_enable_for_rc_prime) ? {'visibility':'visible'} : {'visibility':'hidden'}}>
                            <label className="form-title">Select IP</label>
                            <select className="form-control selectInput" multiple="multiple" id="allowed_ip_address" style={{ width: "100%" }}>
                              {this.state.allowed_ip_addresses_for_rc_prime.map((ip, i) => {
                                if (ip.length > 0) {
                                  return <option key={i} selected>{ip}</option>
                                }
                              })}
                            </select>
                          </div>
                        </div>

                      </div>
                    </div>
                    
                    <div className="submitRow">
                      <NavLink to={"/admin/client-list"} className="backBtn" exact >  Back List</NavLink>
                      <button className="blueBtn" type="submit">Save</button>
                    </div>
                  </form>
                </div>
                
              </div>

            </div>
            <div className="loader">
              <div className="bg"></div>
              <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
            </div>
          </div>
        </React.Fragment>
      )
    } else {
      return (
        <UnAuthorised></UnAuthorised>
      )
    }

  }
}

export default CreateClient;
